import { React } from 'react'

function Semester(props) {
    return (
        <div>
            <div className="container d-flex justify-content-center my-2">
                <button className="btn btn-primary mx-1" onClick={(e) => props.setDisplay('Home')}>Home</button>
                <button className="btn btn-primary mx-2" onClick={(e) => props.setDisplay('Branch')}>Change Branch</button>
            </div>
            <h4 className='text-center'>Your Branch: {props.Branch}</h4>

            <div className="container my-4">
                <h5 className="text-center">Select Semester</h5>
                <div className="row my-3">
                    <div className="">
                        <div id="list-example" className="list-group">
                            <div className="list-group-item list-group-item-action selectors-item"
                                onClick={(e) => { props.setDisplay('Subject'); props.setsemNumber('1') }}
                            >1st Semester</div>
                            <div className="list-group-item list-group-item-action selectors-item"
                                onClick={(e) => { props.setDisplay('Subject'); props.setsemNumber('2') }}
                            >2nd Semester</div>
                            <div className="list-group-item list-group-item-action selectors-item"
                                onClick={(e) => { props.setDisplay('Subject'); props.setsemNumber('3') }}
                            >3rd Semester</div>
                            <div className="list-group-item list-group-item-action selectors-item"
                                onClick={(e) => { props.setDisplay('Subject'); props.setsemNumber('4') }}
                            >4th Semester</div>
                            <div className="list-group-item list-group-item-action selectors-item"
                                onClick={(e) => { props.setDisplay('Subject'); props.setsemNumber('5') }}
                            >5th Semester</div>
                            <div className="list-group-item list-group-item-action selectors-item"
                                onClick={(e) => { props.setDisplay('Subject'); props.setsemNumber('6') }}
                            >6th Semester</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Semester